export async function fallbackCopyTextToClipboard(text: any): Promise<boolean> {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';
  textArea.style.display = 'none';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    if (typeof navigator?.clipboard?.writeText === 'function') {
      await navigator.clipboard.writeText(text);
    } else {
      /**
       * this feature is no longer recommended
       */
      document.execCommand('copy');
    }
  } catch (err) {
    return false;
  } finally {
    document.body.removeChild(textArea);
  }
}
